import { Route } from 'react-router'
import { ROUTES } from '../../constants/routes/routes-generic'
import { TimedOutPage } from './timed-out'
import { UnderReviewPage } from './under-review'
import { AccountExistsPage } from './account-exists'
import { DeclinePage } from './decline'
import { DeviceNotSupportedPage } from './device-not-supported'
import { ErrorPage } from './error'
import { LinkExpiredPage } from './link-expired'
import { TechnicalIssuesPage } from './technical-issues'
import { UnableVerifyPage } from './unable-to-verify'

export const routerGeneric = (): JSX.Element | null => {
  return (
    <>
      <Route path={ROUTES.TIMED_OUT.path} element={<TimedOutPage />} />
      <Route path={ROUTES.UNDER_REVIEW.path} element={<UnderReviewPage />} />
      <Route path={ROUTES.ACCOUNT_EXISTS.path} element={<AccountExistsPage />} />
      <Route path={ROUTES.DECLINE.path} element={<DeclinePage />} />
      <Route path={ROUTES.DEVICE_NOT_SUPPORTED.path} element={<DeviceNotSupportedPage />} />
      <Route path={ROUTES.ERROR.path} element={<ErrorPage />} />
      <Route path={ROUTES.LINK_EXPIRED.path} element={<LinkExpiredPage />} />
      <Route path={ROUTES.TECHNICAL_ISSUES.path} element={<TechnicalIssuesPage />} />
      <Route path={ROUTES.UNABLE_VERIFY.path} element={<UnableVerifyPage />} />
      <Route path={ROUTES.TIMED_OUT.path} element={<TimedOutPage />} />
    </>
  )
}
